import { render, staticRenderFns } from "./other-paylinks-generator.vue?vue&type=template&id=48f77270&scoped=true&"
import script from "./other-paylinks-generator.vue?vue&type=script&lang=js&"
export * from "./other-paylinks-generator.vue?vue&type=script&lang=js&"
import style0 from "./other-paylinks-generator.vue?vue&type=style&index=0&id=48f77270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f77270",
  null
  
)

export default component.exports